import { render, staticRenderFns } from "./editRoleModalContent.vue?vue&type=template&id=d55964e6&scoped=true"
import script from "./editRoleModalContent.vue?vue&type=script&lang=js"
export * from "./editRoleModalContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d55964e6",
  null
  
)

export default component.exports